import React, { useState } from "react";
import { Button } from "semantic-ui-react";
import { BasicModal } from "../../../../components/Shared";
import { useAuth } from "../../../../hooks";
import { ClassList } from "../../../../components/Admin/TeacherCmp";
import { ClaseForm } from "../../../../components/Admin/TeacherCmp/TeacherForm";
import { useTranslation } from "react-i18next";
import "./Page_Institution_Class.scss";

export function Page_Institution_Class() {
  const { user, accessToken } = useAuth();
  const { t } = useTranslation("institutions");

  // Estados para los modales y recargas
  const [showModalClases, setShowModalClases] = useState(false);
  const [reloadClases, setReloadClases] = useState(false);

  // Funciones para alternar y recargar
  const onOpenCloseModalClases = () =>
    setShowModalClases((prevState) => !prevState);
  const onReloadClases = () => setReloadClases((prevState) => !prevState);

  const [reload, setReload] = useState(false); // Estado para forzar la recarga de la lista de escenas
  const onReload = () => setReload((prevState) => !prevState); // Función para forzar la recarga de las escenas

  return (
    <div className="institution-profile-page">
      {/* Sección con botones */}
      <div className="buttons-container">
        <Button className="button-alta" onClick={onOpenCloseModalClases}>
          {t("pages.classAddButton")}
        </Button>
      </div>
      <div>
        {" "}
        <h1>{t("pages.classListTitle")}</h1>
        <ClassList
          user={user}
          accessToken={accessToken}
          reload={reload}
          onReload={onReload}
        />
      </div>

      {/* Modales */}
      <BasicModal
        show={showModalClases}
        close={onOpenCloseModalClases}
        title={t("pages.createClassTitle")}
      >
        <ClaseForm
          user={user}
          close={onOpenCloseModalClases}
          reloadClases={reloadClases}
          accessToken={accessToken}
          onReload={onReloadClases}
        />
      </BasicModal>
      {/* Modales */}
    </div>
  );
}
